import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const SettingsIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M13.335 13.238a1.748 1.748 0 1 1-2.473-2.476 1.748 1.748 0 0 1 2.473 0l.382-.382-.382.382a1.75 1.75 0 0 1 0 2.476Z"
      stroke={color}
      strokeWidth={1.3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M7.827 5.59v-.001l1.384-.84h0l.01-.005c.287-.182.696-.099.907.274l.085.155v.001c.42.776 1.075 1.338 1.884 1.338.809 0 1.465-.561 1.889-1.337h0l.086-.157c.21-.373.62-.456.908-.274h0l.01.006 1.383.839h0c.415.251.584.854.326 1.328-.428.782-.54 1.631-.16 2.328.386.711 1.163 1.049 2.042 1.049.44 0 .869.395.869.96v1.492c0 .56-.426.96-.87.96-.878 0-1.655.338-2.042 1.049-.379.697-.267 1.545.16 2.327.26.484.089 1.078-.325 1.329h0l-1.384.84h0l-.01.005c-.287.182-.696.099-.907-.274l-.085-.155v-.001c-.42-.776-1.075-1.338-1.884-1.338-.809 0-1.464.561-1.889 1.337h0l-.086.157c-.21.373-.62.456-.908.274h0l-.01-.006-1.381-.838s0 0 0 0a.95.95 0 0 1-.417-.58 1.045 1.045 0 0 1 .09-.75c.427-.782.539-1.63.16-2.328-.387-.71-1.164-1.048-2.043-1.048-.443 0-.869-.4-.869-.96v-1.492c0-.56.426-.96.87-.96.878 0 1.655-.338 2.042-1.049.379-.697.267-1.546-.161-2.329l-.57.312.57-.31c-.258-.475-.089-1.078.326-1.329Z"
      stroke={color}
      strokeWidth={1.3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default SettingsIcon;
